import styled from 'styled-components';
import { stickyYellow } from 'tokens';

//----------------------------------------------------------------------
// MARKER (canvas-space, counter-scaled)
//----------------------------------------------------------------------

interface MarkerProps {
	x: number;
	y: number;
	$counterScale: number;
	$hovered: boolean;
	$active: boolean;
}

export const Marker = styled.div<MarkerProps>`
	position: absolute;
	left: ${(p) => p.x}px;
	top: ${(p) => p.y}px;
	pointer-events: none;
	user-select: none;
	transform: scale(${(p) => p.$counterScale});
	transform-origin: top left;
`;

export const MarkerNote = styled.div<{ $hovered: boolean; $active: boolean }>`
	position: relative;
	width: 28px;
	height: 28px;
	margin-left: -14px;
	margin-top: -28px;
	background: ${(p) =>
		p.$active ? stickyYellow.fillActive : p.$hovered ? stickyYellow.fillHover : stickyYellow.fill};
	border: 1px solid ${stickyYellow.border};
	border-radius: 2px 2px 2px 0;
	box-shadow: 1px 2px 4px ${stickyYellow.shadow};
	display: flex;
	align-items: center;
	justify-content: center;
	transition: background 0.1s ease;

	// Corner fold
	&::after {
		content: '';
		position: absolute;
		bottom: 0;
		right: 0;
		width: 7px;
		height: 7px;
		background: linear-gradient(135deg, ${stickyYellow.fold} 50%, ${stickyYellow.foldShadow} 50%);
		border-radius: 0 0 0 2px;
	}

	// Pointer triangle at bottom-left
	&::before {
		content: '';
		position: absolute;
		bottom: -6px;
		left: -1px;
		width: 0;
		height: 0;
		border-left: 7px solid ${stickyYellow.border};
		border-bottom: 6px solid transparent;
	}
`;

export const MarkerLabel = styled.div`
	font-size: 11px;
	font-weight: 700;
	color: ${stickyYellow.text};
	line-height: 1;
	z-index: 1;
`;

